module.exports = __webpack_public_path__ + "media/images/pla/pla19-5c8f5531e4c930670390a28629dc79a1.jpg";